var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMealPlanSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2521 2.19055H10.9378C6.60087 2.19055 4.43241 2.19055 3.0851 3.53786C1.73779 4.88517 1.73779 7.05363 1.73779 11.3906V11.6096C1.73779 15.9465 1.73779 18.115 3.0851 19.4623C4.43241 20.8096 6.60087 20.8096 10.9378 20.8096H12.2521C16.589 20.8096 18.7575 20.8096 20.1048 19.4623C21.4521 18.115 21.4521 15.9465 21.4521 11.6096V11.3906C21.4521 7.05363 21.4521 4.88517 20.1048 3.53786C18.7575 2.19055 16.589 2.19055 12.2521 2.19055Z",
    fill: "#3B1F8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73779 7.66663H21.4521",
    stroke: "white",
    strokeWidth: 1.725,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66626 1.09534V3.57788M16.5234 1.09534V3.57788",
    stroke: "#3B1F8E",
    strokeWidth: 1.725,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.59509,
    cy: 11.5,
    r: 0.5,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5951,
    cy: 11.5,
    r: 0.5,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5951,
    cy: 11.5,
    r: 0.5,
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5951,
    cy: 15.5,
    r: 0.5,
    fill: "#D9D9D9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.59509,
    cy: 15.5,
    r: 0.5,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMealPlanSelected);
export default __webpack_public_path__ + "static/media/mealPlanSelected.135382a65adcb44f3166160cb247a770.svg";
export { ForwardRef as ReactComponent };